import { Reveal } from "./motion/Reveal";

const SectionHeading = ({ number, title, sub, dark = false, className = "" }) => (
  <Reveal className={`mb-12 md:mb-16 ${className}`}>
    <div className="flex items-start gap-4 md:gap-6">
      <span className="font-mono text-sm md:text-base text-brand-red pt-2 md:pt-3 shrink-0">
        /{number}
      </span>
      <div>
        <h2
          className={`font-display text-4xl md:text-5xl font-medium tracking-tight leading-[1.02] ${
            dark ? "text-white" : "text-brand-ink"
          }`}
        >
          {title}
        </h2>
        {sub && (
          <p
            className={`mt-4 max-w-xl text-base md:text-lg leading-relaxed ${
              dark ? "text-white/60" : "text-neutral-500"
            }`}
          >
            {sub}
          </p>
        )}
      </div>
    </div>
  </Reveal>
);

export default SectionHeading;
